import firebaseApp from "../firebase/credenciales";
import { getFirestore, collection, doc, deleteDoc } from "firebase/firestore";
import escribirLog from "./escribirLog";
import Swal from 'sweetalert2'

const db = getFirestore(firebaseApp);

export default async function eliminarProductoHome(producto, autor, baseDatos) {
  
  //Alerta de confirmación
  const { value: confirmar } = await Swal.fire({
    title: '¿Estás seguro?',
    text: "¡No podrás revertir esto!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: '¡Sí, bórralo!'
  })

  //Si se confirma la eliminación
  if (confirmar) {
    //Elimina el producto
    const eliminado = await deleteDoc(doc(collection(db, baseDatos), producto.id))
    escribirLog("Eliminación Documento", producto, autor);
    return eliminado;
    

  } else {
    //Si no se confirma la eliminación, no hace nada
    return;
  }

  

}
